export default __webpack_public_path__ + "static/media/kitchen3-afterI-1920w.eb8ef6f1.webp";